export default __webpack_public_path__ + "static/media/valgt_alvorlig_avvik_fra_kontrollør.43f754a2.svg";